import React from "react";
import { CustomDatatableV2 } from "../../styles";
import { makeDefaultTableOptions } from "../../../../storage/helpers";
import TableTitle from "../../../../components/Table/TableTitle";
import CustomDataTableIcons from "../../../../components/Table/CustomDataTableIcons";
import { MapPin } from "react-feather";
import ProgBarMini from "../retail/ProgBarMini";
import { CenterWithColor } from "../../styles";
import { Alert } from "@mui/material";
import { ENGAGEMENT_TYPES } from "../../../../storage/constants";
import DisplaySpiffyScore from "../../../../components/Table/DisplaySpiffyScore";
import StyledLink from "src/components/UI/StyledLink";

const options = makeDefaultTableOptions("managed-locations");

const retSubsByEngagementType = (obj, engagementType) => {
  try {
    if (engagementType === ENGAGEMENT_TYPES.ALL) {
      return obj.assigned_submissions + obj.extra_credit_submissions;
    }
    if (engagementType === ENGAGEMENT_TYPES.ASSIGNED) {
      return obj.assigned_submissions;
    }
    return obj.extra_credit_submissions;
  } catch (error) {
    return 0;
  }
};

const retCompsByEngagementType = (obj, engagementType) => {
  try {
    if (engagementType === ENGAGEMENT_TYPES.ALL) {
      return obj.assigned_completions + obj.extra_credit_completions;
    }
    if (engagementType === ENGAGEMENT_TYPES.ASSIGNED) {
      return obj.assigned_completions;
    }
    return obj.extra_credit_completions;
  } catch (error) {
    return 0;
  }
};

const MultipleLocationsTable = ({ locations, engagementType, companyName }) => {
  const columns = [
    {
      name: "id",
      label: "",
      options: {
        display: false,
      },
    },
    {
      name: "name",
      label: "Location Name",
      options: {
        customBodyRender: (val, tableMeta) => (
          <StyledLink
            to={`/locations/detail/${tableMeta?.rowData[0]}`}
            value={val}
          />
        ),
      },
    },
    {
      name: "teamMembers",
      label: "Team Members",
    },
    {
      name: "submissions",
      label: "Submissions",
      options: {
        customBodyRender: (val) => (
          <CenterWithColor engagementType={engagementType}>
            {val}
          </CenterWithColor>
        ),
      },
    },
    {
      name: "completions",
      label: "Completions",
      options: {
        customBodyRender: (val) => (
          <CenterWithColor engagementType={engagementType}>
            {val}
          </CenterWithColor>
        ),
      },
    },
    {
      name: "spiffyScore",
      label: "Spiffy Score Avg",
      options: {
        customBodyRender: (val) => <DisplaySpiffyScore val={val} />,
      },
    },
    {
      name: "progress",
      label: "Progress",
      options: {
        customBodyRender: (value, tableMeta) => {
          if (engagementType === ENGAGEMENT_TYPES?.EXTRACREDIT) {
            return <span style={{ color: "darkgrey" }}>---/--- </span>;
          }

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                minWidth: 160,
                maxWidth: 176,
                flexDirection: "column",
              }}
            >
              <ProgBarMini progress={value} />
              <span
                style={{
                  fontSize: 10,
                  color: "slategrey",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  minWidth: 60,
                  marginTop: -3,
                }}
              >
                {`(${tableMeta?.rowData[7]})`} {value}%
              </span>
            </div>
          );
        },
      },
    },
    {
      name: "progressStr",
      label: " ",
      options: {
        display: false,
      },
    },
  ];

  const tableData = locations?.map((location) => ({
    id: location.id,
    name: location?.name,
    teamMembers: location?.team_members,
    submissions: retSubsByEngagementType(location?.submissions, engagementType),
    completions: retCompsByEngagementType(
      location?.submissions,
      engagementType,
    ),
    spiffyScore: location?.average_spiffy_score,
    progress:
      location?.progress.completed_out_of_assigned === 0
        ? 0
        : Math.ceil(
            (location?.progress.completed_out_of_assigned /
              location?.progress.assigned) *
              100,
          ),
    progressStr: `${location?.progress?.completed_out_of_assigned}/${location?.progress.assigned}`,
  }));

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "stretch",
        }}
      >
        <Alert
          severity="info"
          style={{
            border: "1px solid gainsboro",
            borderRadius: 6,
            background: "white",
          }}
        >
          <p>
            You manage
            <strong> {locations?.length} locations </strong>
            at <strong>{companyName}</strong>.
          </p>
        </Alert>
        <div style={{ minHeight: 12 }} />
        <CustomDatatableV2
          title={<TableTitle title="Managed Locations" Icon={MapPin} />}
          options={options}
          columns={columns}
          data={tableData}
          components={{
            icons: CustomDataTableIcons,
          }}
        />
      </div>
    </>
  );
};

export default MultipleLocationsTable;
